import React from "react";
import { Tag } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { TFunction } from "i18next";

export const renderDataScienceStatusTag = (status: string | undefined, t: TFunction) => {
  if (!status) return <Tag color="default">{t("Common-Unknown")}</Tag>;

  const statusConfig: Record<
    string,
    { color: string; icon: React.ReactNode | null }
  > = {
    pending: { color: "processing", icon: <ClockCircleOutlined /> },
    running: { color: "processing", icon: <ClockCircleOutlined /> },
    success: { color: "success", icon: <CheckCircleOutlined /> },
    failed: { color: "error", icon: <CloseCircleOutlined /> },
  };

  const config = statusConfig[status] || {
    color: "default",
    icon: null,
  };

  return (
    <Tag color={config.color} icon={config.icon}>
      {t(`DataScienceJobs-Statuses.${status}`) || status}
    </Tag>
  );
};
